import React, { useEffect } from 'react';
import { TranscriptionPanel } from './components/TranscriptionPanel';
import { TeachingAnalysis } from './components/TeachingAnalysis';
import { ContentFormatter } from './components/ContentFormatter';
import { TeachingContext } from './components/TeachingContext';
import { ConversationContainer } from './components/ConversationContainer';
import { AuthButton } from './components/AuthButton';
import { ApiSettings } from './components/ApiSettings';
import { initializeAuth } from './lib/auth';

function App() {
  useEffect(() => {
    initializeAuth();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-950 to-gray-900 text-gray-100 py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-12">
          <div>
            <h1 className="text-4xl font-bold text-amber-500 font-montserrat tracking-wide">CONTENT WOLF</h1>
            <p className="text-gray-400">Speak your thoughts, let AI structure your teachings</p>
          </div>
          <AuthButton />
        </div>
        
        <ApiSettings />
        <TeachingContext />
        <TranscriptionPanel />
        <TeachingAnalysis />
        <ConversationContainer />
        <ContentFormatter />
      </div>
    </div>
  );
}

export default App;